export enum MessageType {
  INFO = 'info',
  SUCCESS = 'success',
}
